import React from 'react';
import { testimonials } from '../data/content';
import { Reveal } from './Reveal';
export function Testimonials() {
  return <section className="bg-paper px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="colegas" data-id="element-170" data-mp="3krp1qv22efll">
      <div className="mx-auto max-w-6xl" data-id="element-171" data-mp="3fym86mxaf65e">
        <Reveal data-id="element-172" data-mp="3fxb38js3vscp">
          <h2 id="colegas" className="display text-4xl text-ink sm:text-5xl" data-id="element-173" data-mp="3b0ufhqotjg05">
            Lo que dicen los colegas
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-10 sm:grid-cols-2 sm:gap-14" data-id="element-174" data-mp="36zr35e5zc23o">
          {testimonials.map((t, i) => <Reveal key={t.name} delay={i * 0.05} className="h-full" data-id="element-175" data-mp="31yl5d1xgpona" data-mpi={i}>
              <figure className="flex h-full flex-col border-t-2 border-grass pt-6" data-id="element-176" data-mp="2x1ur8k57x34i">
                <blockquote className="text-xl leading-snug text-ink sm:text-2xl" data-id="element-177" data-mp="2s2i561m6802z">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-auto pt-6 text-sm font-bold uppercase tracking-wide text-grass" data-id="element-178" data-mp="v8nd3e1ccrk7">
                  {t.name}
                  <span className="ml-2 font-medium normal-case text-ink-dim" data-id="element-179" data-mp="h5yamk89jn69">
                    {t.place}
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}